import React from 'react';
import { Button, Table } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import t, { partial } from '../../../util/translation/translation';
import FormCard from '../../../shared/components/custom/FormCard';
import SquareIconButton from '../../../shared/components/custom/SquareIconButton';

// Provider types with a readable name; others show as they are
export const PROVIDER_TYPES = [
  'rss',
  'youtube-feed',
  'ntf-rss',
  'sil-rss',
  'sportality',
  'sportalityAPI',
];

const NewsProvidersList = ({ providers }) => {
  const s = partial('shared');
  const p = partial('NewsForm');
  const history = useHistory();
  const typeName = (type) =>
    PROVIDER_TYPES.includes(type) ? p(`providerType-${type}`) : type;

  const renderProviders = () => {
    return providers.map((provider) => {
      return (
        <tr key={`newsProvider-${provider.id}`}>
          <td className="table-stack__primary settings-provider">
            <Link
              to={`/news_providers/edit/${provider.id}`}
              className="font-weight-500"
            >
              {typeName(provider.type)}
            </Link>
            {/* Which feed it is: two of the same type look alike otherwise */}
            {!!provider?.config?.url && (
              <div
                className="settings-provider__url"
                title={provider.config.url}
              >
                {provider.config.url}
              </div>
            )}
          </td>
          <td data-label={s('category')}>
            {provider?.category?.name ? (
              <span className="qb-chip">{provider.category.name}</span>
            ) : (
              <span className="text-muted">–</span>
            )}
          </td>
          <td data-label={p('pushEnabled')}>
            <span
              className={`settings-status${
                provider.pushEnabled ? ' settings-status--on' : ''
              }`}
            >
              {provider.pushEnabled ? s('policiesOn') : s('policiesOff')}
            </span>
          </td>
          <td className="table-stack__actions">
            <div className="icon-actions justify-content-end">
              <SquareIconButton
                icon={<EditOutlineIcon />}
                title={s('edit')}
                id={`edit-provider-${provider.id}`}
                onClick={() =>
                  history.push(`/news_providers/edit/${provider.id}`)
                }
              />
            </div>
          </td>
        </tr>
      );
    });
  };
  return (
    <FormCard
      title={
        <>
          {t('NewsPage.newsProviders')}
          <span className="form-card__count">{providers.length}</span>
        </>
      }
      actions={
        <Link to="/news_providers/create">
          <Button color="primary" size="sm" className="mb-0">
            {p('addProvider')}
          </Button>
        </Link>
      }
      bodyClassName="form-card__body--flush"
      className="mb-3"
    >
      <Table responsive striped className="table--roomy table--stack mb-0">
        <thead>
          <tr>
            <th>{s('type')}</th>
            <th>{s('category')}</th>
            <th>{p('pushEnabled')}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {renderProviders()}
          {!providers.length && (
            <tr>
              <td colSpan={4} className="settings-empty">
                {s('noProviders')}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </FormCard>
  );
};

export default NewsProvidersList;
